import Vue from 'vue';
import { ED_MODAL_EVENTS } from '@/plugins/ed-modal/ed-modal.plugin';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { IParamsModalGrade } from '../../interfaces/params-modal-grade.interface';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { decimal, maxValue, required } from 'vuelidate/lib/validators';
import { _HOMEWORKS_STORE, GRADING_SCALES, GRADING_EVENTS } from '@/homework/values/homeworks.values';

@Component({})
export default class EdModalGrade extends Vue {

  public form: any = null;
  public modalMounted: boolean = false;
  public shown: boolean = false;
  public params: IParamsModalGrade = null;
  public maxlength: number = 3;
  public decimalPlaces: number = 2;
  public gradeType: any = 1;
  public scale: any = null;
  public scaleGrades: any = null;
  public gradeMethod: any = null;
  public gradingDetails: any = [];
  public loading: boolean = true;
  public gradeSelected: any = new Array(1);
  public gradingScales: any = GRADING_SCALES;
  public validateGrade: string = GRADING_EVENTS.VALIDATE_GRADE;

  get classes() {
    return { 'ed-modal-grade-container--shown': this.shown }
  }

  get classId() {
    return this.$store.state.HomeworksStore.teacherWidgetHomeworks.courseOpened.classId 
      || this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.courseOpened.classId
  }

  get actionText() {
    if(this.params.hasGrading){
      return this.$i18n.t('courses.grade.modalActionWithGrade');
    }else if(this.form.grade.value) {
      return this.$i18n.t('courses.grade.modalActionWithGrade');
    } else {
      return this.$i18n.t('courses.grade.modalActionWithoutGrade');
    }
  }

  get answers() {
    return this.params?.section?.section?.type == 'LESSON_SPLIT_TYPE' ? 
      JSON.parse(this.params?.section?.section?.text)?.answerPoints : [];
  }

  get homeworkPoints() {
    return this.gradeMethod == GRADING_SCALES.POINTS ? this.params.section.section?.homeworkPoints : null;
  }

  get hasGrading() { 
    return this.params.hasGrading;
  }

  public actionModal() {
    if(this.hasGrading) {
      if(this.gradeType == 2) this.gradingDetails = [];
      this.params.action({grades: this.gradingDetails});
      this.gradingDetails = [];
      this.resetVModelSelect();
      this.init();
    } else {
      this.params.action({grades: this.form.grade?.value});
    }
    this.hide();
  }

  public closeModal() {
    this.gradingDetails = [];
    this.resetVModelSelect();
    this.init();
    this.hide();
  }

  public show() {
    this.modalMounted = true;
    setTimeout(() => {
      this.shown = true;
    }, 100);
  }

  public hide() {
    this.shown = false;
    setTimeout(() => {
      this.modalMounted = false;
    }, 300);
  }

  public setGradeModal(params: IParamsModalGrade) {
    this.params = params;
    this.show();
  }

  private setMaxLenth(value: string) {
    let initLength = 3;
    if (this.gradeMethod == this.gradingScales.POINTS && this.hasGrading)
      initLength = 4
    
    if(value.length == initLength) {
      this.maxlength = initLength + 1;
    } else if (value.length > initLength || value.length < initLength) {
      let included: boolean = value.includes('.');
      if(included) {
        let length: number = value.indexOf('.') + 1;
        this.maxlength = length + this.decimalPlaces;
      } else  { 
        this.maxlength = initLength; 
        value = '0'
      }
    }
  } 

  public setSingleScaleForSubmit(value) {
    this.gradingDetails = [{
      item: 1,
      type: this.gradeMethod,
      value: Number(value)
    }]
  }

  public setScaleForSubmit(index) {
    let item = {
      item: index + 1,
      type: this.gradeMethod,
      value: this.gradeSelected[index]
    }
    this.gradingDetails = this.gradingDetails.filter(el => el.item != index + 1);
    this.gradingDetails.push(item);
  }

  public init() {
    if(this.hasGrading) {
      if (this.answers?.length > 0) {
        this.form = EdFormModel([]);
        for(let i = 0; i < this.answers.length; i++){
          this.form.setInput(EdInputModel(`grades${i}`, '', { required }));
        } 
      } else {
        this.form = EdFormModel([
          EdInputModel('grade', '', { required })
        ]);
      }
    } else {
      this.form = EdFormModel([
        EdInputModel('grade', '', {maxValue: maxValue(100)})
      ]);
    }
  }

  public resetVModelSelect() {
    if (this.answers?.length > 0) {
      this.gradeSelected = new Array(this.answers.length);
    } else {
      this.gradeSelected = new Array(1);
    }
  }

  public validateInput(field, index) {
    if((this.gradeMethod == this.gradingScales.PERCENTAGE || this.gradeMethod == this.gradingScales.POINTS) || !this.hasGrading) {
      let value: string = null;
      let replaced: boolean = false;
      let regex: RegExp = /[^0-9.]/g;
      /* does not allow characters other than numbers and periods */
      value = this.form[field].value.replace(regex , (match: string) => {
        replaced = match ? true :false;
        return '';
      }); 
      if(!replaced) {
        let regex: RegExp = /^0\d/g;
        /* does not allow numbers after zero if it is at the beginning */
        value = this.form[field].value.replace(regex, (match: string , val1: string) => {
          replaced = match ? true : false;
          return val1;
        });   
      }
      if(replaced) {
        let valid: boolean = this.form.valid;
        this.form.set(field, value);
        this.form.setValid(field, valid);
      }
      this.setMaxLenth(value);
      if (this.maxlength < value.length) {
        this.form[field].value = this.form[field].value.slice(0, -1)
      }
      if(this.form[field].value) {
        let item = {
          item: index + 1,
          type: this.gradeMethod,
          value: Number(this.form[field].value)
        }
        this.gradingDetails = this.gradingDetails.filter(el => el.item != index + 1);
        this.gradingDetails.push(item);
      } else {
        this.gradingDetails = this.gradingDetails.filter(el => el.item != index + 1);
      }
    }
  }

  created() {
    this.$EdModal.$on(ED_MODAL_EVENTS.ED_CREATE_GRADE_MODAL, this.setGradeModal);
  }

  @Watch('params')
  getHomeworkScale() {
    if (this.hasGrading && this.params.homeworkId) {
      this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.GET_HOMEWORK_SCALE, {homeworkId: this.params.homeworkId})
        .then((res) => {
          this.gradeMethod = res.type;
          this.scale = res;
          this.loading = false;
          this.scaleGrades = this.scale.grades.map(el => {
            return {
              value: el.id,
              text: el.grade
            }
          })
        })
    } else {
      this.loading = false;
    }
  }

  @Watch('answers')
  setVModelSelect() {
    this.resetVModelSelect();
    this.init();
  }

  @Watch('form', { immediate: false, deep: true })
  setValue() {
    if(this.answers?.length == 0 || !this.hasGrading) {
      this.validateInput('grade', 0);
    }
  }
}
